import React from 'react';
import { Helmet } from 'react-helmet-async';
import './LegalPage.css';

const TermsAndConditions = () => {
    return (
        <div className="legal-container">
            <Helmet>
                <title>Terms & Conditions | RiyaMaga</title>
                <meta name="description" content="Read the Terms and Conditions for using the RiyaMaga vehicle marketplace platform." />
            </Helmet>

            <div className="legal-header">
                <h1>Terms & Conditions</h1>
                <p className="legal-updated">Last updated: February 2025</p>
            </div>

            <div className="legal-body">
                <section className="legal-section">
                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing or using RiyaMaga ("the Platform"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use the Platform.</p>
                </section>

                <section className="legal-section">
                    <h2>2. Eligibility</h2>
                    <p>You must be at least 18 years old to register and use RiyaMaga. By creating an account, you confirm that all information you provide is accurate and complete.</p>
                </section>

                <section className="legal-section">
                    <h2>3. User Accounts</h2>
                    <ul>
                        <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                        <li>You must notify us immediately of any unauthorized use of your account.</li>
                        <li>Each user may only maintain one active account.</li>
                        <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>4. Ad Listings</h2>
                    <p>When posting an ad on RiyaMaga:</p>
                    <ul>
                        <li>All information must be accurate, truthful, and not misleading.</li>
                        <li>You must own or have the legal right to sell or advertise the vehicle or item listed.</li>
                        <li>Images must be of the actual vehicle being advertised.</li>
                        <li>Individual accounts are limited to 3 active listings.</li>
                        <li>Corporate accounts can post unlimited listings.</li>
                        <li>We reserve the right to remove any listing that violates our policies.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>5. Prohibited Content</h2>
                    <p>You may not post content that:</p>
                    <ul>
                        <li>Is false, misleading, or fraudulent</li>
                        <li>Infringes on intellectual property rights</li>
                        <li>Contains stolen, illegal, or counterfeit goods</li>
                        <li>Is offensive, abusive, or harmful</li>
                        <li>Violates any applicable law or regulation</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>6. Transactions</h2>
                    <p>RiyaMaga is a listing platform only. We are not a party to any transaction between buyers and sellers. We do not guarantee the quality, safety, or legality of items listed. All transactions are conducted at your own risk.</p>
                </section>

                <section className="legal-section">
                    <h2>7. Intellectual Property</h2>
                    <p>All content on the RiyaMaga platform, including logos, design, and code, is the property of RiyaMaga. You may not copy, modify, or distribute our content without written permission.</p>
                    <p>By posting ads, you grant RiyaMaga a non-exclusive license to display your content on the platform.</p>
                </section>

                <section className="legal-section">
                    <h2>8. Limitation of Liability</h2>
                    <p>RiyaMaga is provided "as is" without any warranties. To the maximum extent permitted by law, RiyaMaga shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the platform.</p>
                </section>

                <section className="legal-section">
                    <h2>9. Governing Law</h2>
                    <p>These Terms shall be governed by and construed in accordance with the laws of Sri Lanka. Any disputes arising shall be subject to the exclusive jurisdiction of the courts of Sri Lanka.</p>
                </section>

                <section className="legal-section">
                    <h2>10. Changes to Terms</h2>
                    <p>We reserve the right to modify these Terms at any time. Continued use of the platform after changes constitutes acceptance of the new terms.</p>
                </section>

                <section className="legal-section">
                    <h2>11. Contact</h2>
                    <p>For questions about these Terms, contact us at:</p>
                    <p><strong>Email:</strong> legal@riyamaga.site</p>
                    <p><strong>Address:</strong> Colombo, Sri Lanka</p>
                </section>
            </div>
        </div>
    );
};

export default TermsAndConditions;
